import { Box, InputAdornment, TextField } from '@mui/material';
import React, { useState } from 'react';
import nextIcon from 'assets/pagination/nextIcon.svg';
import doubleFirstIcon from 'assets/pagination/doubleFirstIcon.svg';
import doubleLastIcon from 'assets/pagination/doubleLastIcon.svg';
import prevIcon from 'assets/pagination/prevIcon.svg';
import searchIcon from 'assets/pagination/searchIcon.svg';
import './CustomPagination.css'

const CustomPagination = ({ data, itemsPerPage, totalItems, paginate, currentPage, setItemsPerPage }) => {
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const [searchPage, setSearchPage] = useState('');
  const handlePageChange = (page) => {
    setSearchPage('')
    if (page < 1 || page > totalPages) return; // Prevent out of bounds pages
    paginate(page, itemsPerPage);

  };

  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(Number(event.target.value));
    setItemsPerPage(Number(event.target.value))
    paginate(1, Number(event.target.value));
    setSearchPage('')
  };

  const handleSearchChange = (event) => {
    const value = event.target.value;
    if (value && !isNaN(value) && value <= totalPages && value >= 1) {
      setSearchPage(value);
    } else {
      setSearchPage('');
    }
  };
  const handleSearchSubmit = (event) => {
    event.preventDefault();
    if (searchPage && searchPage <= totalPages && searchPage >= 1) {
      paginate(searchPage, itemsPerPage);
    }
  };
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage);
  // const currentItems = data.slice(startIndex, endIndex);
  const generatePageNumbers = () => {
    const pages = [];
    if (totalPages >= 3) {
      pages.push(1, 2, 3);

    } else {
      if (totalPages == 1) {
        pages.push(1);
      }
      if (totalPages == 2) {
        pages.push(1,2);
      }
    }

    pages.push(
      <form key="searchForm" onSubmit={handleSearchSubmit}>
        <TextField  label="Go to page..." id="outlined-size-normal" type="number" defaultValue="Normal"
          min={1}
          max={totalPages}
          value={searchPage}
          onChange={handleSearchChange}
          size='small'
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <img src={searchIcon} />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                <img style={{ cursor: "pointer" }} src={nextIcon} onClick={handleSearchSubmit} />
              </InputAdornment>
            ),
          }}
          InputLabelProps={{
            style: { fontSize: '9px', fontWeight: 600 }
          }}
          sx={{
            width: "100px",
            '& input[type="number"]::-webkit-outer-spin-button': {
              display: 'none',
            },
            '& input[type="number"]::-webkit-inner-spin-button': {
              display: 'none',
            },
            '& input[type="number"]': {
              MozAppearance: 'textfield',
            },
          }}
        />
      </form>
    );
    for (let i = currentPage - 1; i <= currentPage + 1; i++) {
      if (i > 3 && i < totalPages) {
        pages.push(i);
      }
    }
    if (totalPages >3) {
      pages.push(totalPages);
    }

    return pages;
  };

  return (
    <Box className="paginationContainer" sx={{ display: "flex", padding: "10px 0px", flexDirection: "row", backgroundColor: "white", justifyContent: "space-between", alignItems: "center" }}>
      <Box sx={{ width: "159px" }} className="rows-per-page">
        <select className='paginationPerPage' value={itemsPerPage} onChange={handleRowsPerPageChange} id="rowsPerPage">
        {/* <option value={2} className='paginationOptions'>2 Rows</option> */}
          <option value={10} className='paginationOptions'>10 Rows</option>
          <option value={20}>20 Rows</option>
          {/* <option value={35}>35 Rows</option> */}
          <option value={50}>50 Rows</option>
          <option value={100}>100 Rows</option>
        </select>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
        <Box className='paginationBox'>
          <img src={doubleFirstIcon}
            className='paginationIcon'
            onClick={() => handlePageChange(1)} disabled={currentPage === 0} />
        </Box>
        <Box className='paginationBox'>
          <img src={prevIcon}
            className='paginationIcon'
            onClick={() => handlePageChange((currentPage + 1) - 1)} disabled={currentPage === 0} />
        </Box>
        {generatePageNumbers().map((page, index) =>
          typeof page === 'number' ? <Box
          onClick={() => handlePageChange(page)}
          className={`paginationBox ${(currentPage + 1) == page ? 'paginationActive' : ''}`}>
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
              key={index}
            >
              {page}
            </Box>
          </Box> : (
            page
          )
        )}
        <Box className='paginationBox' >
          <img src={nextIcon}
            className='paginationIcon'
            onClick={() => handlePageChange((currentPage + 1) + 1)} disabled={(currentPage + 1) === totalPages} />
        </Box>
        <Box className='paginationBox'>
          <img src={doubleLastIcon}
            className='paginationIcon'
            onClick={() => handlePageChange(totalPages)} disabled={(currentPage + 1) === totalPages} />
        </Box>
      </Box>
    </Box>
  );
};


export default CustomPagination